var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 10.2649 2.23857 8.04762 5 8.04762C7.76144 8.04762 10 10.2649 10 13H8.75C8.75 10.9487 7.07106 9.28572 5 9.28572C2.92893 9.28572 1.25 10.9487 1.25 13H0ZM5 7.42857C2.92812 7.42857 1.25 5.76643 1.25 3.71429C1.25 1.66214 2.92812 0 5 0C7.07188 0 8.75 1.66214 8.75 3.71429C8.75 5.76643 7.07188 7.42857 5 7.42857ZM5 6.19048C6.38125 6.19048 7.5 5.08238 7.5 3.71429C7.5 2.34619 6.38125 1.2381 5 1.2381C3.61875 1.2381 2.5 2.34619 2.5 3.71429C2.5 5.08238 3.61875 6.19048 5 6.19048Z",
    fill: "#5B73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllLive);
export default __webpack_public_path__ + "static/media/all-live.2d41ebc396128ebb708e1a2f1d697ceb.svg";
export { ForwardRef as ReactComponent };